import dayjs from 'dayjs';

export const getDate = (date) => {           // Jun 24, 2024
    const options = { month: 'short', day: 'numeric', year: 'numeric' };
    const formattedDate = new Date(date).toLocaleDateString('en-US', options);
    return formattedDate;
}

export const getTime = (date) => {           // 12:00 AM
    const options = { hour: 'numeric', minute: 'numeric', hour12: true };
    const formattedTime = new Date(date).toLocaleTimeString('en-US', options);
    return formattedTime;
}

export const timeAgo = (timestamp) => {
    const now = new Date();
    const createdAt = new Date(timestamp);
    const diffInSeconds = Math.floor((now - createdAt) / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);
    
    if (diffInSeconds < 60) {
        return 'Just now';
    } else if (diffInMinutes < 60) {
        return `${diffInMinutes} minute${diffInMinutes > 1 ? 's' : ''} ago`;
    } else if (diffInHours < 24) {
        return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
    } else if (diffInDays < 30) {
        return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
    } else {
        return createdAt.toLocaleDateString(); // or any date format you prefer
    }
};

export const formatDate = (date) => {
    return dayjs(date);
};
